import * as React from "react"
import { Link } from "react-router";
import CTA, {CTATheme} from "./common/CallToAction";

const NotFoundPage = () => {
    return (
      <div className="not-found">
        <img src="/images/icons/404.svg" />
        <Link to="/">
          <CTA innerText={"Go To Home"} theme={CTATheme.PRIMARY} onClick={() => {}}/>
        </Link>
      </div>
    );
}

export default NotFoundPage